import type { DocEntityHandle } from "building-types/handles/docEntityHandleTypes";
import type { FeetCubed, FeetSquared, WorldFeet } from "common/types/nominalNumbersTypes";

export interface StandardFoundationKeyMeasure {
  readonly category: FoundationKeyMeasureType;
  readonly name: string;
  readonly order: number;
  count?: number;
  length?: WorldFeet;
  area?: FeetSquared;
  volume?: FeetCubed;
  readonly handles: DocEntityHandle[];
}

export enum FoundationKeyMeasureType {
  FOOTING = "Footing",
  SLAB = "Slab",
}

export type StandardFoundationKeyMeasureSet = { [key: string]: StandardFoundationKeyMeasure };
